// Entry point for the build script in package.json

import Rails from "@rails/ujs";
import "@hotwired/turbo-rails";
import * as ActiveStorage from "@rails/activestorage";
import "core-js/stable";
// Bootstrap is already imported by Niiwin, so leave this line commented out.
// import "bootstrap";
import "tom-select/dist/js/tom-select.complete.js";
import "trix";
import "@rails/actiontext";

Rails.start();
ActiveStorage.start();

// eslint-disable-next-line import/first
import "./controllers";

// Add specific icons we use from FontAwesome 6. All other icons will use FA5 as provided by Niiwin
import {
  faCalculator,
  faExclamationCircle,
  faFire,
  faHandsClapping,
  faLanguage,
  faLaptopCode,
  faListCheck,
  faMasksTheater,
  faUsersRectangle,
  faQuestion,
} from "@fortawesome/free-solid-svg-icons";
FontAwesome.library.add(
  faCalculator,
  faExclamationCircle,
  faFire,
  faHandsClapping,
  faLanguage,
  faLaptopCode,
  faListCheck,
  faMasksTheater,
  faUsersRectangle,
  faQuestion,
);

// Prevents image flicker
// https://fontawesome.com/docs/web/use-with/rails-turbolinks
FontAwesome.config.mutateApproach = "sync";

// Custom Turbo Actions
Turbo.StreamActions.create_datagrid_row = function () {
  document.dispatchEvent(
    new CustomEvent("create-datagrid-row", {
      detail: {
        id: this.getAttribute("id"),
        data: JSON.parse(this.getAttribute("data")),
      },
    }),
  );
};

Turbo.StreamActions.update_datagrid_row = function () {
  document.dispatchEvent(
    new CustomEvent("update-datagrid-row", {
      detail: {
        id: this.getAttribute("id"),
        data: JSON.parse(this.getAttribute("data")),
      },
    }),
  );
};

Turbo.StreamActions.remove_datagrid_row = function () {
  document.dispatchEvent(
    new CustomEvent("remove-datagrid-row", {
      detail: {
        ids: this.getAttribute("ids"),
      },
    }),
  );
};

Turbo.StreamActions.reload_datagrid_data = function () {
  document.dispatchEvent(new CustomEvent("reload-datagrid-data"));
};

Turbo.StreamActions.push_state = function () {
  const url = this.getAttribute("url");
  if (url) {
    const currentState = window.history.state || {};
    window.history.pushState({ ...currentState }, "", url);
  }
};

Turbo.StreamActions.replace_state = function () {
  const url = this.getAttribute("url");
  if (url) {
    const currentState = window.history.state || {};
    window.history.replaceState({ ...currentState }, "", url);
  }
};

Turbo.StreamActions.redirect = function () {
  const url = this.getAttribute("url");
  if (url) {
    window.location.href = url;
  }
};

Turbo.StreamActions.open_new_tab = function () {
  const url = this.getAttribute("url");
  if (url) {
    window.open(url, "_blank", "noopener");
  }
};
